import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';

import { errorMsg } from '@lib/utils';
import App from './App';
import RNListener from './listener/RNListener';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //   staleTime: 1000,
      //   cacheTime: 2000,
      refetchOnWindowFocus: false,
      enabled: false,
      retry: false,
      onError: (err) => errorMsg(err),
    },
  },
});
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <RNListener>
        <App />
      </RNListener>
      {/* {isLocal() && <ReactQueryDevtools />} */}
    </BrowserRouter>
  </QueryClientProvider>
);
